import React, { useLayoutEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import useFullscreenImage from '../../hooks/useFullscreenImage'
import preventEvents from '../../utils/preventEvents'
import ScrollButtonIcon from '../Icons/ScrollButton/ScrollButtonIcon'

interface ScrollButtonProps {
  direction: 'top' | 'bottom'
  display: boolean
  scrollHandler: (to: 'bottom' | 'top') => void
  className: string
}

const ScrollButton = ({ direction, display, scrollHandler, className }: ScrollButtonProps): JSX.Element => {
  const themeColors = useSelector((state: RootState) => state.viewReducer.themeColors)
  const fullScreenImage = useFullscreenImage()
  const divRef = useRef<HTMLDivElement>(null)

  const handleClick = (): void => {
    scrollHandler(direction)
  }

  useLayoutEffect(() => {
    divRef?.current && preventEvents(divRef.current)
  })

  return display && !fullScreenImage ? (
    <div id='ScrollButton' ref={divRef} className={className} onClick={handleClick}>
      <ScrollButtonIcon className={`${direction === 'top' ? 'rf-rotate-0' : 'rf-rotate-180'}`} color={themeColors.primary} />
    </div>
  ) : (
    <></>
  )
}

export default ScrollButton
